import React from 'react'

const Termsbanner = () => {
    return (
        <div>
            <section className="page-header">
                <div className="page-header-bg"></div>
                <div className="container">
                    <div className="page-header__inner">
                        <div className="innerbanner">
                            <h4 className="text-custom-white no-margin">Terms and Condition</h4>
                        </div>
                        <h6 className='para_absdasa'>Best quotes for you !!!</h6>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Termsbanner
